import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslations } from "../../contexts/translationContext";
import ControlFeedback from "./ControlFeedback";
import { SelectListControlProps, SelectListOption, UdfOption } from "./Types";
import DataService from "../../services/data.service"
import { useNotifications } from "../../contexts/notificationContext";

const SelectListControl: React.FC<SelectListControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur, options, optionsUrl, nullOption }) => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [hasFocus, setFocus] = useState(false);
    const [listOptions, setListOptions] = useState(options);

    const { translate } = useTranslations();
    const { handleException } = useNotifications();


    useEffect(() => {
        if (optionsUrl) {
            if (!nullOption) {
                DataService.get<SelectListOption[]>(optionsUrl)
                    .then(response => setListOptions(() => response))
                    .catch(e => handleException(e));
            }
            else {
                if (optionsUrl.indexOf('?') > -1) {
                    optionsUrl += '&nullOption=-- ';
                }
                else {
                    optionsUrl += '?nullOption=-- ';
                }

                translate(nullOption).then(translated => {
                    DataService.get<SelectListOption[]>(optionsUrl + translated)
                        .then(response => setListOptions(() => response))
                        .catch(e => handleException(e));
                });
            }
        }
    }, [optionsUrl, nullOption])

    useEffect(() => {
        setListOptions(options)
    }, [options])

    function onControlChange(e: any) {
        onChange(e.value);
    }

    function onMenuOpen() {
        setMenuOpen(true);
        setFocus(true);
    };

    function onMenuClose() {
        setMenuOpen(false);
    }

    function onControlBlur() {
        setFocus(false);
        if (onBlur)
            onBlur();
    }

    //console.log('Options: ', listOptions)
    //console.log('Looking for value: ', value)

    let v = value;
    if (listOptions && listOptions.length > 0) {
        v = listOptions[0];
        listOptions.forEach(function (option: SelectListOption | UdfOption<string>) {
            if (option.value == value) {
                //console.log('option found: ', option)
                v = option;
            }
        });
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true

    let className = "form-control select " + (isMenuOpen ? "menu-open" : (hasFocus ? "menu-focus" : "menu-closed"));

    if (width === undefined)
        width = '100%';

    //console.log('Validation results:', name, validationResults)

    return (
        <div style={{ width: width }}>
            <Select
                custom
                className={className}
                name={name}
                value={v}
                isDisabled={disabled}
                options={listOptions}
                placeholder={null}
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                onBlur={onControlBlur}
                onChange={onControlChange}
                isInvalid={!isValid}
                theme={(theme: any) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary25: 'lightgray',
                        primary: 'gray',
                    },
                })}
            />
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default SelectListControl;